import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  imports: [TranslocoPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'teilrecht-back-link',
  templateUrl: './teilrecht-back-link.component.html',
})
export class TeilrechtBackLinkComponent {
  @Input() public label?: string;
  @Output() public back = new EventEmitter<void>();
}
